'use es6';

import { render } from 'react-dom';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import Raven from 'raven-js';
import userInfo from 'hub-http/userInfo';
import ContentRoutes from 'ContentUtils/Routes';
import { getShouldSendCallback } from 'ContentUtils/helpers/sentry';
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import { SuspensionBannersContextProvider } from 'ui-suspension-banners-lib';
import { createBrowserHistory } from 'history';

// Redux
import 'redux';
import { Provider } from 'react-redux';
import configureStore from './utils/redux/configureStore';
import { setupBreadcrumbCallback } from './utils/raven';

// Configure the router
import { Router } from 'react-router-dom';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import routes from './Routes';
import { filterFileManagerSpecificGates } from 'FileManagerCore/utils/gates';
import LoadingFailed from 'FileManagerCore/components/LoadingFailed';
import { getRootUrl, isUsingLegacyRoute, rewriteInitialRoute } from './utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
class Application {
  // Kicks off the app. This is intentionally not in the constructor just in
  // case there is a reason you need to explictly call init (and don't want it
  // auto-called by importing this module)
  start() {
    window.AppInstance = this;
    Raven.setShouldSendCallback(getShouldSendCallback);
    this.init().then(auth => {
      const {
        user,
        portal
      } = auth;
      const history = createBrowserHistory({
        basename: getRootUrl()
      });
      this.startRedux(auth, history);
      return BasicI18nSetup.setup({
        lang,
        user,
        portal
      });
    }).then(() => {
      this.startRouter(this.history);
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }

  // Performs all the initialization needed before the main app code can run/render.
  init() {
    return userInfo().then(auth => {
      const {
        user
      } = auth;
      Raven.setUserContext({
        id: user.user_id,
        email: user.email,
        locale: user.locale
      });
      setupBreadcrumbCallback();
      ContentRoutes.init(auth.gates);
      return auth;
    });
  }
  startRedux(auth, history) {
    const {
      user,
      portal
    } = auth;
    if (isUsingLegacyRoute(history.location)) {
      rewriteInitialRoute(history);
    }
    const gates = filterFileManagerSpecificGates(auth.gates);
    this.store = configureStore({
      auth: {
        user,
        gates,
        portal
      }
    }, history);
    this.history = history;
  }
  startRouter(history) {
    render( /*#__PURE__*/_jsx(RhumbProvider, {
      config: rhumbConfig,
      history: historyAdapter(history),
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(SuspensionBannersContextProvider, {
          children: /*#__PURE__*/_jsx(ErrorBoundary, {
            ErrorComponent: LoadingFailed,
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: routes
            })
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }
}
new Application().start();